import { Box, RenderHtml, Text } from '@betty/moonlight';
import { State, useSelector } from '@betty/toolkit/state';
import { memo } from 'react';
import { selectQuest } from '../../../state';
import QuestProgress from './QuestProgress/QuestProgress';
import { QuestStatus } from '../../../services/QuestsService.schemas';

function AdditionalInfo({ id }: { id: number }) {
  const quest = useSelector((state: State) => selectQuest(state, id));
  if (!quest) {
    return null;
  }
  const {
    subTypeMeta,
    subPromoType,
    longDescription,
    termsAndConditions,
    status,
  } = quest;

  return (
    <Box width="100%" marginVertical="space-400">
      <Box
        gap="space-800"
        width="100%"
        alignSelf="center"
        maxWidth={{
          mobile: undefined,
          tablet: undefined,
          desktop: 666,
        }}
      >
        {status !== QuestStatus.Completed && status !== QuestStatus.Locked ? (
          <QuestProgress
            subTypeMeta={subTypeMeta}
            subPromoType={subPromoType}
            showMainLabel={true}
          />
        ) : null}
        <Box gap="space-400">
          <Box>
            <Text
              variant="h5"
              gradient="darkSurfaceAccent"
              locNS="quests"
              locKey="howItWorks"
            />
            <RenderHtml
              html={termsAndConditions}
              variant="body-m-semi"
              color="darkSurfacePrimary"
            />
          </Box>
          <Box>
            <Text
              variant="h5"
              gradient="darkSurfaceAccent"
              locNS="common"
              locKey="terms"
            />
            <RenderHtml
              html={longDescription}
              variant="body-m-semi"
              color="darkSurfacePrimary"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default memo(AdditionalInfo);
